import Vue from "vue"
import Vuelidate from "vuelidate"
import VCalendar from "v-calendar"
import "v-calendar/lib/v-calendar.min.css"

import App from "./App.vue"
import router from "./router"
import store from "@/store"

Vue.config.productionTip = false

Vue.use(Vuelidate)

Vue.use(VCalendar, {
  firstDayOfWeek: 1 // 1 = sun 2 = Monday
})

// do auth check?
import { fetchLocalAuthInfo } from "@/store/modules/auth/providers/localStorage"
import { refreshToken } from "./store/modules/auth/providers/api"

const init = async () => {
  try {
    const localAuth = fetchLocalAuthInfo()

    if (localAuth) {
      store.commit("setAuthInfo", localAuth)
      // refresh access token with refresh token
      try {
        const res = await refreshToken()
        const { accessToken } = res.data
        store.commit("setAccessToken", accessToken)
      } catch (err) {
        store.dispatch("clearAuth")
        console.log("error refreshing access token", err)
      }
    }
  } catch (err) {
    console.log("error initializing app", err)
  }
}

const renderApp = async () => {
  await init()
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount("#app")
}

renderApp()
